import React, { Component } from 'react';
import SignupForm from '../SignupForm';

// This is currently built only for onboarding
class CreateAccount extends Component {
  handleClickRequestResetPassword = evt => {
    const { onClickRequestResetPassword } = this.props;
    onClickRequestResetPassword();
  };

  render() {
    const {
      anyTouched,
      error,
      onSubmit,
      routing,
      submitting,
      feedUrl,
    } = this.props;
    const { location } = this.props.routing;
    return (
      <SignupForm
        anyTouched={anyTouched}
        error={error}
        onSubmit={onSubmit}
        routing={routing}
        submitting={submitting}
        location={location}
        feedUrl={feedUrl}
      />
    );
  }
}

export default CreateAccount;
